export enum ShareableViews {
  ActivityGlucoseGraph = 'ActivityGlucoseGraph',
  MealDetail = 'MealDetail',
}
